export default function (value, code = 'EUR', locale = null, format = null) {
  const options = {
    style: 'currency',
    currency: code
  }

  if (!locale) {
    locale = window.navigator.language || window.navigator.userLanguage || process.env.VUE_APP_I18N_LOCALE || 'es'
  }

  const nf = new Intl.NumberFormat(locale, options)

  if (format === 'parts') {
    return nf.formatToParts(value)
  }

  return nf.format(value)
}
